import DateHelper from '@/helpers/date';

export default {
    state: {
        fromDate: DateHelper.getDateThisMonth(),
        toDate: DateHelper.getDateToday(),
        websiteId: '',
    },
    mutations: {
        setDates(state, dates) {
            state.fromDate = dates.from
            state.toDate = dates.to
        },
        setWebsiteId(state, websiteId) {
            state.websiteId = websiteId
        }
    },

    getters: {
        getState(state) {
            return state
        },
        getDates(state) {
            return {
                from: state.fromDate,
                to: state.toDate
            }
        },
        getWebsiteId(state) {
            return state.websiteId
        }
    },
    namespaced: true
}
